import { useEffect, useState } from 'react';
import { FlaskConical } from 'lucide-react';
import { demoMode } from '@/lib/demoMode';

// Persistent thin banner shown while Client-Side Demo Preview is ON so no one
// mistakes fixture data for live data. Rendered at the app root; unmounts
// itself when the flag flips off. Tap → disable demo mode.
export default function DemoModeBanner() {
  const [on, setOn] = useState(() => demoMode.isEnabled());
  useEffect(() => demoMode.subscribe(setOn), []);
  if (!on) return null;
  return (
    <button
      onClick={() => { demoMode.disable(); window.location.reload(); }}
      data-testid="demo-mode-banner"
      className="fixed top-0 left-0 right-0 z-[100] bg-[#B91C1C] text-white text-[11px] font-semibold tracking-wider uppercase flex items-center justify-center gap-2 h-[24px] hover:bg-[#a51818] transition-colors"
    >
      <FlaskConical size={12} strokeWidth={2.4} />
      Demo mode ON — Matches / Likes / Messages / Views are fixtures · tap to exit
    </button>
  );
}
